<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose"
  >
    <h4 style="text-align: center; margin-bottom: 20px">
      《{{ courseName }}》
    </h4>
    <el-button
      type="danger"
      style="position: absolute; right: 70px; top: 56px"
      size="mini"
      @click="delZkolExaminationSyllabusList"
      >清除考试大纲</el-button
    >
    <div style="text-align: center">自学考试课程考试大纲知识点表</div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#d7d7d7' }"
    >
      <el-table-column label="序号" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="自学考试课程考试大纲知识点"
        min-width="300"
      >
      </el-table-column>
      <el-table-column prop="section" label="所在大纲章节"> </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </el-dialog>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
export default {
  name: 'KnowledgeInser',
  components: {},
  inject: ['reload'],
  props: ['courseName', 'courseWareId'],
  data() {
    return {
      dialogVisible: false,
      institutionId: '',
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
    }
  },
  methods: {
    // 初始化
    init() {
      this.dialogVisible = true
    },
    getZkolExaminationSyllabusList() {
      const courseWareId = this.courseWareId || this.$route.query.id
      const page = this.pageObj.page
      const pageSize = this.pageObj.pageSize
      api
        .getZkolExaminationSyllabusList({ courseWareId, page, pageSize })
        .then(({ data }) => {
          if (data.code === 100000) {
            this.tableData = data.data.list
            this.total = data.data.total
          }
        })
    },
    delZkolExaminationSyllabusList() {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
        center: true,
      })
        .then(() => {
          const courseWareId = this.courseWareId || this.$route.query.id
          api
            .delZkolExaminationSyllabusList({
              courseWareId,
            })
            .then(({ data }) => {
              if (data.code === 100000) {
                this.tableData = []
                this.total = 0
                this.$message.success(data.msg)
                this.$emit('knowledgeGetList')
              } else {
                this.$message.error(data.msg)
              }
            })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('closeTestSyllabus')
    },
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        if (data.code == 100000) {
          data = data.data
          console.log(data)
          this.institutionId = data.id
        }
      })
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getZkolExaminationSyllabusList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getZkolExaminationSyllabusList()
    },
  },
  created() {
    this.getZkolExaminationSyllabusList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') || '4'
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
